// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ElevatorGroupControl } from './elevator-group-control';


export class ElevatorGroupControlMessage implements flatbuffers.IUnpackableObject<ElevatorGroupControlMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ElevatorGroupControlMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsElevatorGroupControlMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorGroupControlMessage):ElevatorGroupControlMessage {
  return (obj || new ElevatorGroupControlMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsElevatorGroupControlMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorGroupControlMessage):ElevatorGroupControlMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ElevatorGroupControlMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():ElevatorGroupControl {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ElevatorGroupControl.SEC;
}

static startElevatorGroupControlMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:ElevatorGroupControl) {
  builder.addFieldInt16(0, message, ElevatorGroupControl.SEC);
}

static endElevatorGroupControlMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createElevatorGroupControlMessage(builder:flatbuffers.Builder, message:ElevatorGroupControl):flatbuffers.Offset {
  ElevatorGroupControlMessage.startElevatorGroupControlMessage(builder);
  ElevatorGroupControlMessage.addMessage(builder, message);
  return ElevatorGroupControlMessage.endElevatorGroupControlMessage(builder);
}

unpack(): ElevatorGroupControlMessageT {
  return new ElevatorGroupControlMessageT(
    this.message()
  );
}


unpackTo(_o: ElevatorGroupControlMessageT): void {
  _o.message = this.message();
}
}

export class ElevatorGroupControlMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: ElevatorGroupControl = ElevatorGroupControl.SEC
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return ElevatorGroupControlMessage.createElevatorGroupControlMessage(builder,
    this.message
  );
}
}
